import React from 'react';
import {CellProps, Column, Renderer} from 'react-table';

import {ChevronSmallDown, ChevronSmallRight} from '../../assets/images';
import {EIconSmallButton} from '../EButtons';

import {ETableCell, ETableRow} from './types';

/** Expansion column specification. */
export const expansionColumn = <Key extends string>(): Column<ETableRow> => ({
  Header: '',
  accessor: '_expander',
  disableSortBy: true,
  Cell: ((args: CellProps<ETableRow<Key>>) => {
    if (!args.row.original.options?.expansion) {
      return null;
    }
    const rowExpandend: {onClick?: () => void} = {
      ...args.row.getToggleRowExpandedProps?.(),
    };
    return (
      <EIconSmallButton onClick={rowExpandend.onClick}>
        {args.row.isExpanded ? <ChevronSmallDown /> : <ChevronSmallRight />}
      </EIconSmallButton>
    );
    // fix for the linting error - the type is not exactly correct but good enough
    // to do it the right way a more specific type examination is needed
    // might not be necessary if we wanted to upgrade to the new tanstack table anyway
  }) as Renderer<CellProps<ETableRow, ETableCell>> | undefined,
  SubCell: () => '', // No expander on an expanded row
});
